import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import { updateAboutUsOSPara, getAboutUsOSPara, createAboutUsOSPara } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  paragraph1: Yup.string()
    .required("Paragraph 1 is required"),
  paragraph2: Yup.string()
    .required("Paragraph 2 is required"),
  paragraph3: Yup.string()
    .required("Paragraph 3 is required"),
});

export default function OurStoryParaEdit() {
  const { id, partnerId } = useParams();

  const [isUpdating, setIsUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const [data, setStepCard] = useState({
    paragraph1: "",
    paragraph2: "",
    paragraph3: "",
    index: null,
  });

  const getInitialValues = () => ({
    paragraph1: data.paragraph1 || "",
    paragraph2: data.paragraph2 || "",
    paragraph3: data.paragraph3 || "",
  });

  const fetchOurStoryData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }

    try {
      const res = await getAboutUsOSPara(id);
      const ourStoryParaData = res.data.data[0];
      console.log(res);
      setStepCard({
        ...ourStoryParaData, 
        index: res.data.data.indexOf(ourStoryParaData)
      });
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to fetch our story paragraph data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOurStoryData();
  }, [id]);

  const handleSubmit = async (values) => {
    setIsUpdating(true);
    const formData = {
      paragraph1: values.paragraph1,
      paragraph2: values.paragraph2,
      paragraph3: values.paragraph3,
    };

    try {
      if (!Number(id)) {
        formData.partner_id = partnerId;
        const res = await createAboutUsOSPara(formData);
        if (res.status === 200) {
          const ourStoryParaData = res.data.data;
          showToast({
            type: 'success',
            message: res?.data?.message || 'Our story paragraph section has been created successfully!',
          });
          setStepCard(ourStoryParaData);
          if (ourStoryParaData && ourStoryParaData.id) {
            navigate(`/${partnerId}/aboutus/our_story_paragraph/edit/${ourStoryParaData.id}`);
          }
        } else {
          showToast({
            type: 'error',
            message: res?.data?.message || 'Failed to create our story paragraph section. Please try again.',
          });
        }
      } else {
        const res = await updateAboutUsOSPara(id, formData);
        if (res.status === 200) {
          showToast({
            type: 'success',
            message: res?.data?.message || 'Our story paragraph section has been updated successfully!',
          });
          console.log(res.data);
          setStepCard(res.data.data);
        } else {
          showToast({
            type: 'error',
            message: res?.data?.message || 'Failed to update our story paragraph section. Please try again.',
          });
        }
      }
    } catch (err) {
      showToast({
        type: 'error',
        message: err?.response?.data?.message || 'Failed to update our story paragraph section. Please try again.',
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
    {isLoading ? <CmsCircularProgress/> :  
    <FormWrapper>
      <Title>{Number(id) ? 'Edit' : 'Add' } our story paragraph section</Title>
      <SliderDiv>
        <Formik
          initialValues={getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({
            errors,
            touched,
            handleSubmit,
            getFieldProps,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <FormGroup 
                label="Enter a New Paragraph 1" 
                requiredField
                error={touched.paragraph1 && errors.paragraph1 ? errors.paragraph1 : ''}
              >
                <Form.Control
                  as="textarea"
                  rows={6}
                  {...getFieldProps('paragraph1')}
                  placeholder="Enter paragraph 1 content here..."
                  isInvalid={touched.paragraph1 && !!errors.paragraph1}
                />
              </FormGroup>

              <FormGroup 
                label="Enter a New Paragraph 2" 
                requiredField
                error={touched.paragraph2 && errors.paragraph2 ? errors.paragraph2 : ''}
              >
                <Form.Control
                  as="textarea"
                  rows={4}
                  {...getFieldProps('paragraph2')}
                  placeholder="Enter paragraph 2 content here..."
                  isInvalid={touched.paragraph2 && !!errors.paragraph2}
                />
              </FormGroup>

              <FormGroup 
                label="Enter a New Paragraph 3" 
                requiredField
                error={touched.paragraph3 && errors.paragraph3 ? errors.paragraph3 : ''}
              >
                <Form.Control
                  as="textarea"
                  rows={4}
                  {...getFieldProps('paragraph3')}
                  placeholder="Enter paragraph 3 content here..."
                  isInvalid={touched.paragraph3 && !!errors.paragraph3}
                />
              </FormGroup>

              <ButtonWrapper className="mt-3">
                <Link
                  to={`/${partnerId}/aboutus/our_story_paragraph/view/${Number(id) ? id : 'create'}`}
                  style={{
                    width: "50%",
                  }}
                >
                  <Button variant="secondary">Go Back</Button>
                </Link>
                <Button
                  type="submit"
                  style={{
                    width: "50%",
                  }}
                  disabled={isUpdating || isSubmitting}
                >
                  {isUpdating ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </SliderDiv>
    </FormWrapper>}
    </>
  );
}

const FormWrapper = styled.div`
 @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 2rem;
@media (max-width: 890px) {
  gap: 2rem;
}
 @media (max-width: 425px) {
  gap: 1rem;
}
`;
